import axios from 'axios';
import { API_BASE_URL } from './globals';

// Create axios instance with base URL
const apiProvider = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor - add auth headers if available (commented out for now)
// apiProvider.interceptors.request.use(
//     (config) => {
//         // Get token from localStorage if available
//         const token = localStorage.getItem('authToken');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

// Response interceptor - handle common errors
apiProvider.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized (commented out for now)
        // if (error.response?.status === 401) {
        //     localStorage.removeItem('authToken');
        //     localStorage.removeItem('userData');

        //     // Only redirect if not already on login page
        //     if (window.location.pathname !== '/login') {
        //         window.location.href = '/login';
        //     }
        // }

        // Handle 403 Forbidden (commented out for now)
        // if (error.response?.status === 403) {
        //     console.error('Access forbidden');
        // }

        // Handle network errors
        if (!error.response) {
            console.error('Network error - please check your connection');
        }

        return Promise.reject(error);
    }
);

export default apiProvider;
